<!-- eslint-disable complexity -->
<template>
    <div class="d-flex flex-column overflow-hidden">
        <b-form
            v-on:submit.prevent="$_onSubmit"
            class="d-flex flex-column overflow-hidden"
        >
            <div class="scrollable mb-3">
                <b-container>
                    <category
                        :categories="categories"
                        :accordion="true"
                        :inputFields="inputFields"
                        id="brk"
                        @onInput="$_validateInput($event)"
                        :invalidFieldValueErrorMessage="
                            invalidFieldValueErrorMessage
                        "
                    />
                </b-container>
            </div>
            <div v-if="invalidForm" class="errormsg px-4 mb-2">
                {{ invalidFormErrorMessage }}
            </div>
            <b-container>
                <b-row>
                    <b-col class="text-right pb-4">
                        <b-button variant="primary" type="submit">
                            <span>
                                {{ $t('searchButtonText') }}
                            </span>
                        </b-button>
                    </b-col>
                </b-row>
            </b-container>
        </b-form>
    </div>
</template>

<script>
    import { mapState, mapGetters, mapActions } from 'vuex';
    import Category from './ApiCategory.vue';
    import {
        SELECTION_TYPES,
        THEMELAYER_PARCELS_BRK,
        MAX_RESULTS_RELATION,
        FIELD_TYPE
    } from '../../../constants';

    const SEARCH_CATEGORIES = {
        CADASTRAL_DESIGNATION: 1,
        ADDRESS: 2,
        LEGAL_OWNER: 3
    };

    export default {
        components: { category: Category },
        data() {
            return {
                categories: [
                    {
                        label: this.$t('nedbrk.searchCat1'),
                        category: SEARCH_CATEGORIES.CADASTRAL_DESIGNATION,
                        expanded: true
                    },
                    {
                        label: this.$t('nedbrk.searchCat2'),
                        category: SEARCH_CATEGORIES.ADDRESS,
                        tables: ['brk_perceel_adres', 'brk_perceel_appartement'],
                        expanded: false
                    },
                    {
                        label: this.$t('nedbrk.searchCat3'),
                        category: SEARCH_CATEGORIES.LEGAL_OWNER,
                        tables: ['brk_gerechtigde'],
                        expanded: false
                    }
                ],
                invalidFieldValueErrorMessage: '',
                invalidForm: false,
                invalidFormErrorMessage: '',
                inputFields: [
                    // Cadastral designation
                    {
                        label: this.$t('nedbrk.cadastralDesignation'),
                        key: 'object_geo_code',
                        value: '',
                        category: SEARCH_CATEGORIES.CADASTRAL_DESIGNATION,
                        maxlength: 12
                    },
                    {
                        label: this.$t('nedbrk.municipalName'),
                        key: 'kadastrale_gemeentenaam',
                        value: '',
                        category: SEARCH_CATEGORIES.CADASTRAL_DESIGNATION,
                        maxlength: 100
                    },
                    {
                        label: this.$t('nedbrk.municipalCode'),
                        key: 'kadastrale_gemeentecode',
                        value: '',
                        category: SEARCH_CATEGORIES.CADASTRAL_DESIGNATION,
                        maxlength: 5,
                        pattern: '^([a-zA-Z]{3}[0-9]{2})$',
                        placeholder: this.$t('format.nLettersNDigits', [3, 2]),
                        title: this.$t('format.nLettersNDigits', [3, 2])
                    },
                    {
                        label: this.$t('nedbrk.section'),
                        key: 'sectie',
                        value: '',
                        category: SEARCH_CATEGORIES.CADASTRAL_DESIGNATION,
                        maxlength: 2,
                        pattern: '^[a-zA-Z]{1,2}$',
                        placeholder: this.$t('format.maxNLetters', [2]),
                        title: this.$t('format.maxNLetters', [2])
                    },
                    {
                        label: this.$t('nedbrk.parcelNumber'),
                        key: 'perceelnummer',
                        value: '',
                        category: SEARCH_CATEGORIES.CADASTRAL_DESIGNATION,
                        maxlength: 5,
                        placeholder: this.$t('format.maxNDigits', [5]),
                        title: this.$t('format.maxNDigits', [5])
                    },
                    {
                        label: this.$t('nedbrk.apartmentsRightSerialNumber'),
                        key: 'appartementsrecht_volgnr',
                        value: '',
                        category: SEARCH_CATEGORIES.CADASTRAL_DESIGNATION,
                        maxlength: 4,
                        placeholder: this.$t('format.maxNDigits', [4]),
                        title: this.$t('format.maxNDigits', [4])
                    },
                    // Address
                    {
                        label: this.$t('nedbrk.townName'),
                        key: 'bag_openbareruimte_woonplaats',
                        value: '',
                        category: SEARCH_CATEGORIES.ADDRESS,
                        maxlength: 100
                    },
                    {
                        label: this.$t('kvk.straatnaam'),
                        key: 'bag_openbareruimtenaam',
                        value: '',
                        category: SEARCH_CATEGORIES.ADDRESS,
                        maxlength: 100,
                        minlength: 3
                    },
                    {
                        label: this.$t('brk.postalCode'),
                        key: 'bag_postcode',
                        value: '',
                        category: SEARCH_CATEGORIES.ADDRESS,
                        maxlength: 6,
                        pattern: '[1-9][0-9]{3}(?!sa|sd|ss|SA|SD|SS)[A-Za-z]{2}',
                        placeholder: this.$t('format.nDigitsNLetters', [4, 2]),
                        title: this.$t('format.nDigitsNLetters', [4, 2])
                    },
                    {
                        label: this.$t('brk.houseNumber'),
                        key: 'bag_huisnummer',
                        value: null,
                        category: SEARCH_CATEGORIES.ADDRESS,
                        maxlength: 5,
                        type: FIELD_TYPE.NUMERIC,
                        placeholder: this.$t('format.maxNDigits', [5]),
                        title: this.$t('format.maxNDigits', [5])
                    },
                    {
                        label: this.$t('brk.houseLetter'),
                        key: 'bag_huisletter',
                        value: '',
                        category: SEARCH_CATEGORIES.ADDRESS,
                        maxlength: 1,
                        pattern: '^[a-zA-Z]{1}$',
                        placeholder: this.$t('format.nLetters',[1]),
                        title: this.$t('format.nLetters',[1])
                    },
                    {
                        label: this.$t('brk.houseNumberAddition'),
                        key: 'bag_huisnummertoevoeging',
                        value: '',
                        category: SEARCH_CATEGORIES.ADDRESS,
                        maxlength: 4,
                        pattern: '^[0-9a-zA-Z]{1,4}$',
                        placeholder: this.$t('format.maxNDigitsOrLetters', [4]),
                        title: this.$t('format.maxNDigitsOrLetters', [4])
                    },
                    // Titleholder
                    {
                        label: this.$t('nedbrk.titleHolderName'),
                        key: 'naam',
                        value: '',
                        category: SEARCH_CATEGORIES.LEGAL_OWNER,
                        maxlength: 100
                    },
                    {
                        label: this.$t('kvk.kvkNumber'),
                        key: 'kvknummer',
                        value: '',
                        category: SEARCH_CATEGORIES.LEGAL_OWNER,
                        maxlength: 8,
                        pattern: '[0-9]{8}([0-9]{1})?',
                        placeholder: this.$t('format.nDigits', [8, 's']),
                        title: this.$t('format.nDigits', [8, 's'])
                    },
                    {
                        label: this.$t('brk.citizenServiceNumber'),
                        key: 'bsn',
                        value: '',
                        category: SEARCH_CATEGORIES.LEGAL_OWNER,
                        minlength: 8,
                        maxlength: 9,
                        pattern: '[0-9]{8}([0-9]{1})?',
                        placeholder: this.$t('format.nOrNDigits', [8, 9]),
                        title: this.$t('format.nOrNDigits', [8, 9])
                    }
                ]
            };
        },

        computed: {
            ...mapState(['objectSearchResults']),
            ...mapGetters([
                'getMainMap',
                'getTableSearchResultByTablename',
                'getThemeByName',
                'getLayerByName'
            ]),

            searchResultCount() {
                return this.objectSearchResults.reduce(
                    (sum, item) => sum + item.count,
                    0
                );
            }
        },

        methods: {
            ...mapActions(['searchTableData']),

            async $_onSubmit() {
                let expandedCategory = this.$_categoryExpanded();
                let query = {};
                // Only add fields that have a value
                this.inputFields.forEach((item) => {
                    const value =
                        typeof item.value === 'string'
                            ? item.value.trim()
                            : item.value;
                    if (
                        value !== null &&
                        value !== '' &&
                        item.category === expandedCategory.category
                    ) {
                        query[item.key] =
                            typeof value === 'string'
                                ? value
                                : JSON.stringify(value);
                        // Postal code input should be uppercase
                        if (item.key === 'bag_postcode') {
                            query[item.key] = query[item.key].toUpperCase();
                        }
                    }
                });

                this.$store.commit('CLEAR_SELECTIONS');
                this.$store.commit('NEDGLOBE_MOBILE_DISPLAY_SELECTION_START');

                let features = [];

                if (this.$_isValidForm(query)) {
                    let inputFilters = this.$_createFiltersFromInput(query);

                    // Category 'Cadastral Designation' will behandled differently than the other two categories.
                    if (
                        expandedCategory.category ===
                        SEARCH_CATEGORIES.CADASTRAL_DESIGNATION
                    ) {
                        // Search through themelayer 'Percelen (BRK)'
                        const layer = this.getLayerByName(THEMELAYER_PARCELS_BRK);
                        // Search for features
                        features = await this.$store.dispatch(
                            'searchFeaturesOnLayerWithCustomFilters',
                            {
                                layerId: layer.id,
                                filters: inputFilters
                            }
                        );

                        // Limit the number of features, because too many will crash the page.
                        if (features.length > MAX_RESULTS_RELATION) {
                            features = features.slice(0, MAX_RESULTS_RELATION);
                        }

                        // Display the results
                        this.$store.dispatch('displaySelection', {
                            data: {
                                location: null,
                                results: [
                                    {
                                        layer: layer,
                                        features,
                                        limitedResults: false
                                    }
                                ],
                                type: SELECTION_TYPES.SEARCH
                            }
                        });
                    } else {
                        // To prevent messaging for every tablesearch, we turn it off.
                        this.$store.commit('MESSAGING_ACTIVE', false);

                        // Search through an array of tables.
                        for (let tableName of expandedCategory.tables) {
                            const tableResult =
                                this.getTableSearchResultByTablename(tableName);
                            if (tableResult) {
                                await this.searchTableData({
                                    title: tableResult.title,
                                    id: tableResult.id,
                                    objectData: inputFilters
                                });
                            }
                        }

                        // Activate messaging again.
                        this.$store.commit('MESSAGING_ACTIVE', true);

                        // Collect the features in the searchresult (for zooming in)
                        if (this.searchResultCount > 0) {
                            for (const result of this.objectSearchResults) {
                                if (result.count > 0) {
                                    if (result.data.features) {
                                        for (const feature of result.data
                                            .features) {
                                            features.push(feature);
                                        }
                                    }
                                }
                            }
                        } else {
                            // Give a meaagse on no results.
                            this.$store.commit('ADD_STATUS_MESSAGE', {
                                message: this.$t('noResultsFound'),
                                variant: 'warning',
                                autoHideDelay: 5000
                            });
                        }
                    }

                    // Zoom to found features
                    if (features.length > 0) {
                        this.$store.dispatch('zoomToFeatures', {
                            mapName: 'main',
                            features: features,
                            zoomWhenOutOfView: false,
                            minResolution: this.getMainMap?.viewport?.resolution
                        });
                    }
                }

                this.$store.commit('NEDGLOBE_MOBILE_DISPLAY_SELECTION_END');
            },

            $_createFiltersFromInput(input) {
                let filters = [];
                for (const [key, value] of Object.entries(input)) {
                    filters.push({
                        filterAttribute: key,
                        columnName: key,
                        dataType: 'string',
                        operator: '=',
                        value: value,
                        caseSensitive: false,
                        visible: true
                    });
                }
                return filters;
            },

            // eslint-disable-next-line complexity
            $_missingSearchFieldsMessage(_query) {
                const query = JSON.parse(JSON.stringify(_query));
                if (!query) {
                    return this.$t('brk.missingSearchFields');
                }
                const nFields = Object.keys(query).length;

                // Error when all fields are empty
                if (nFields === 0) {
                    return this.$t('brk.missingSearchFields');
                } else {
                    return '';
                }
            },

            $_isValidForm(query) {
                this.invalidForm = false;
                this.invalidFormErrorMessage =
                    this.$_missingSearchFieldsMessage(query);
                if (this.invalidFormErrorMessage) {
                    this.invalidForm = true;
                    return false;
                }

                if (this.$_hasInvalidStateFields(query)) {
                    this.invalidFormErrorMessage = this.$t(
                        'incorrectInputAllFields'
                    );
                    this.invalidForm = true;
                    return false;
                }
                return true;
            },
            $_hasInvalidStateFields(query) {
                const invalidFields = this.inputFields.filter(
                    ({ state }) => state === false
                );
                return invalidFields.length > 0;
            },
            $_validateInput(field) {
                if (field.type === undefined) {
                    field.state = !field.value.includes('*');
                    this.invalidFieldValueErrorMessage =
                        field.state === true || field.state === null
                            ? ''
                            : this.$t('brk.wildcarNotSupported');
                }
            },
            $_categoryExpanded() {
                return this.categories.find((item) => item.expanded);
            }
        }
    };
</script>

<style scoped lang="scss">
.scrollable {
    overflow-y: auto;
}
</style>
